import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {typeEvents} from '../../enum/type-events';

import {PubSubService} from '../../services/pub-sub.service';
import {Feedback, FeedbackService} from '../../services';
import {Individu, IndividuService} from '@Common/core/services';

@Component({
  selector: 'bdc-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  @Output() onSend: EventEmitter<boolean> = new EventEmitter();

  commentText = '';
  comment: Feedback;

  private connecte: Individu = null;

  constructor(private pubsubService: PubSubService,
              private individuSvc: IndividuService,
              private feedBackSvc: FeedbackService) {

  }

  ngOnInit() {
    this.individuSvc.individu$.subscribe(_individu => { this.connecte = _individu; });
  }

  saveComment() {
    if (this.commentText) {
      this.comment = <Feedback> {
        message: this.commentText,
        commentator: this.connecte ? this.connecte.uid : null
      };

      // debugger;
      this.feedBackSvc.create(this.comment).subscribe((c) => {
        this.pubsubService.publish(typeEvents.commentSaved, 'Merci de votre message, il a bien été enregistré');
        this.onSend.emit(true);
      });
    }
  }
}
